import { Icon } from '@iconify/react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Switch,
} from '@nextui-org/react';

interface VoiceSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  enableAudio: boolean;
  onEnableAudioChange: (enabled: boolean) => void;
  onSave: () => void;
  isLoading?: boolean;
}

export default function VoiceSettingsModal({
  isOpen,
  onClose,
  enableAudio,
  onEnableAudioChange,
  onSave,
  isLoading = false,
}: VoiceSettingsModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      placement="center"
      hideCloseButton={true}
    >
      <ModalContent>
        <ModalHeader className="flex justify-between items-center">
          <span>Voice Settings</span>
          <Button isIconOnly variant="light" onPress={onClose}>
            <Icon icon="mdi:close" className="h-5 w-5" />
          </Button>
        </ModalHeader>

        <ModalBody>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 border border-divider rounded-lg">
              <div className="flex flex-col gap-1">
                <h3 className="text-medium font-medium">Enable Audio</h3>
                <p className="text-small text-default-500">
                  Allow this agent to use voice input and output capabilities
                </p>
              </div>
              <Switch
                isSelected={enableAudio}
                onValueChange={onEnableAudioChange}
                color="primary"
                size="lg"
              />
            </div>

            {enableAudio && (
              <div className="p-4 bg-primary-50 dark:bg-primary-900/20 rounded-lg">
                <div className="flex items-start gap-3">
                  <Icon
                    icon="mdi:information-outline"
                    className="h-5 w-5 text-primary mt-0.5 flex-shrink-0"
                  />
                  <div className="text-small text-default-600">
                    <p className="font-medium mb-1">Audio Features Enabled</p>
                    <p>
                      Users can now interact with this agent using voice input
                      and receive audio responses. This includes speech-to-text
                      and text-to-speech capabilities.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </ModalBody>

        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onPress={onClose}>
            Cancel
          </Button>
          <Button color="primary" onPress={onSave} isLoading={isLoading}>
            Save Settings
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
